import React from "react";
import Banner from "../components/home/Banner";
import NewCareer from "../components/home/NewCareer";
import Welcomecoachmodal from "../components/Welcomecoachmodal";
import Footer from "../components/Footer";
import Wearehiring from "../components/Wearehiring";
import Createresume from "../components/Createresume";
import Createinsights from "../components/Createinsights";
import OurClients from "../components/home/OurClients";
import ShowcaseTalent from "../components/home/ShowcaseTalent";
import Coaches from "../components/Coaches";
import Layout from "../assets/Layout";
const Home = () => {
    return (
        <>
            <Banner />
            <Coaches />
            <NewCareer />
            <Wearehiring />
            <ShowcaseTalent />
            <Createresume />
            <OurClients />
            <Createinsights />
            <Footer />
        </>
    );
}

export default Home;

